import React from 'react';
import Button from '../Button/Button';
import './ToggleBtn.css';
var ToggleBtn = function (props) {
    var activateText = props.activateText, deactivateText = props.deactivateText, _a = props.variant, variant = _a === void 0 ? 'subtle' : _a, size = props.size, iconClass = props.iconClass, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.toggleOn, toggleOn = _c === void 0 ? true : _c, onChange = props.onChange, className = props.className;
    return (React.createElement(Button, { variant: variant, size: size, iconClass: iconClass, disabled: disabled, customClass: toggleOn && (activateText === null || activateText === '')
            ? 'active'
            : '', onClick: onChange, className: className }, toggleOn ? activateText : deactivateText));
};
export default React.memo(ToggleBtn);
